// import samplePage from './sample-page';
// import pages from './pages';
// import dynamicMenu from '../ui-component/DynamicMenu';
import pages from "./pages";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [pages]
};

export default menuItems;
